<template>
  <div>
    <div class="card-title">
    <slot name="title"></slot>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Card",

  }
</script>

<style scoped>
  .card-title {
    padding:0 15px;
    height: 46px;
    background: rgba(238, 238, 238, 1);
    box-shadow: 0px 1px 0px 0px rgba(244, 244, 244, 1);
    line-height: 46px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(73, 80, 96, 1);
  }

  .content {
    background-color: white;
    padding: 15px;

  }

</style>
